import { useCallback, useEffect } from 'react';
import { IconType } from 'react-icons/lib';
import { RiCheckboxCircleLine, RiErrorWarningLine } from 'react-icons/ri';
import { twMerge } from 'tailwind-merge';
import { useAlerts } from './alerts-provider';
import { Alert } from './types';

const icons = {
    failure: RiErrorWarningLine,
    warning: RiErrorWarningLine,
    success: RiCheckboxCircleLine,
    info: RiCheckboxCircleLine,
};

const classes = {
    failure: 'bg-error-200 text-white',
    warning: 'bg-warning-200 text-white',
    success: 'bg-success-200 text-white',
    info: 'bg-success-200 text-white',
};

const TIME_TO_DISMISS = 5000;

const renderIcon = (Component: IconType) => <Component className="h-6 w-6 text-white mr-1" />;

export function AlertComponent({ severity, message, id }: Readonly<Alert>) {
    const { remove } = useAlerts();

    const classNames = twMerge(
        'flex items-center p-4 w-full min-w-xs max-w-lg text-white rounded-lg shadow min-w-[300px]',
        classes[severity],
    );
    const icon = icons[severity];

    const handleClose = useCallback(() => remove(id), [remove, id]);

    useEffect(() => {
        setTimeout(() => remove(id), TIME_TO_DISMISS);
    }, [remove, id]);

    return (
        <div className={classNames}>
            {renderIcon(icon)}
            <h2 className="text-sm font-normal">{message}</h2>
            <div className="flex items-center ml-auto space-x-2">
                <button
                    type="button"
                    className="ml-2 text-white cursor-pointer rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 inline-flex h-8 w-8"
                    aria-label="Close"
                    onClick={handleClose}
                >
                    <svg
                        aria-hidden="true"
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
    );
}
